import React from 'react';
import { Card, Skeleton, Row, Col } from 'antd';

export const FormSkeleton = ({ fields = 8, columns = 2 }) => {
  const span = 24 / columns;

  return (
    <div className="form-skeleton" style={{ width: '100%', marginTop: 16 }}>
      {/* Form Page Header */}
      <div style={{ marginBottom: 20 }}>
        <Skeleton.Input active style={{ width: 260, height: 26, borderRadius: 4, marginBottom: 8 }} />
        <Skeleton.Input active size="small" style={{ width: 180, height: 14, borderRadius: 3, display: 'block' }} />
      </div>

      {/* Main Form Card */}
      <Card bordered={false} style={{ width: '100%', borderRadius: 6, marginBottom: 20 }}>
        <Row gutter={[24, 20]}>
          {Array.from({ length: fields }).map((_, idx) => (
            <Col key={'field_' + idx} span={span} xs={24} md={span}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <Skeleton.Input
                  active
                  size="small"
                  style={{ width: '' + (40 + ((idx * 17) % 35)) + '%', height: 14, borderRadius: 3 }}
                />
                <Skeleton.Input
                  active
                  block
                  style={{ width: '100%', height: 38, borderRadius: 4 }}
                />
              </div>
            </Col>
          ))}
        </Row>

        {/* Textarea field skeleton */}
        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Skeleton.Input active size="small" style={{ width: '25%', height: 14, borderRadius: 3 }} />
          <Skeleton.Input active block style={{ width: '100%', height: 80, borderRadius: 4 }} />
        </div>

        {/* Form Actions Footer */}
        <div
          style={{
            marginTop: 28,
            paddingTop: 18,
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 12
          }}
        >
          <Skeleton.Button active style={{ width: 110, height: 38, borderRadius: 4 }} />
          <Skeleton.Button active style={{ width: 140, height: 38, borderRadius: 4 }} />
        </div>
      </Card>
    </div>
  );
};

export default FormSkeleton;

